import { useEffect, useState } from "react";
import { createRoute, getRoutes, updateRoute } from "../../api/userApi";
import Navbar from "../../components/Navbar";
import { routesFetcher } from "../../services/onlandsite";
import { useAlert } from "../../context/AlertContext";

const emptyForm = {
    id: null,
    route_code: "",
    route_name: "",
    description: "",
    status: "ACTIVE",
};

export default function RouteManagement() {
    const [routes, setRoutes] = useState([]);
    const [form, setForm] = useState(emptyForm);
    const [loading, setLoading] = useState(false);

    const { showAlert } = useAlert();

    const landRoutes = async () => {
        const routes = await routesFetcher();
        setRoutes(routes);
    }

    useEffect(() => {
        landRoutes()
    }, []);

    const onChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (form.id) {
            await updateRoute(form.id, form);
        } else {
            await createRoute(form);
        }

        setForm(emptyForm);
        setLoading(false);
        await routesFetcher(true);
        landRoutes()
        showAlert({ message: "Route changes saved!", type: "success" });
    };

    const onEdit = (route) => setForm(route);

    return (
        <div className="min-h-screen">
            <Navbar />

            <div className="max-w-5xl mx-auto p-6 space-y-6">
                {/* FORM */}
                <h2 className="text-xl font-semibold">Route Management</h2>
                <form
                    onSubmit={onSubmit}
                    className="bg-white p-5 rounded-lg shadow space-y-4"
                >
                    <h2 className="text-lg font-semibold">
                        {form.id ? "Edit Route" : "Add Route"}
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* <input
                            name="route_code"
                            placeholder="Route Code"
                            value={form.route_code}
                            onChange={onChange}
                            required
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
                        /> */}
                        <input
                            name="route_name"
                            placeholder="Route Name"
                            value={form.route_name}
                            onChange={onChange}
                            required
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
                        />
                    </div>

                    <textarea
                        name="description"
                        placeholder="Description"
                        value={form.description}
                        onChange={onChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
                    />

                    <select
                        name="status"
                        value={form.status}
                        onChange={onChange}
                        className="w-40 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
                    >
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="INACTIVE">INACTIVE</option>
                    </select>

                    <div className="flex gap-2">
                        <button
                            disabled={loading}
                            className="px-5 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-60"
                        >
                            {form.id ? "Update" : "Save"}
                        </button>

                        {form.id && (
                            <button
                                type="button"
                                onClick={() => setForm(emptyForm)}
                                className="px-5 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                        )}
                    </div>
                </form>

                {/* LIST */}
                <div className="bg-white rounded-lg shadow overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-100 text-left">
                            <tr>
                                <th className="p-3">Code</th>
                                <th>Name</th>
                                <th>Status</th>
                                <th className="w-20"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {routes?.length && routes.map((r) => (
                                <tr
                                    key={r.id}
                                    className="border-t border-gray-200 hover:bg-gray-50"
                                >
                                    <td className="p-3">{r.route_code}</td>
                                    <td>{r.route_name}</td>
                                    <td>
                                        <span
                                            className={`px-2 py-1 rounded text-xs ${r.status === "ACTIVE"
                                                ? "bg-green-100 text-green-700"
                                                : "bg-gray-200 text-gray-700"
                                                }`}
                                        >
                                            {r.status}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            onClick={() => onEdit(r)}
                                            className="text-blue-600 hover:underline"
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            ))}

                            {!routes.length && (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="p-4 text-center text-gray-400"
                                    >
                                        No routes found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
